import Viewer, { BaseViewer } from "./Viewer";

export default Viewer;

export {
	BaseViewer,
};
